<template lang="pug">
  .c-popup(v-show="param.popup" @click="param.popup = false")
    .c-popup__operate.col-24.color-white.flexD.flexDirectionRow.justifySpaceBetween.alignItemsCenter.m-width-90.m-maxWidthNone(@click="stopPropagation($event)")
      .width10EM
      .flexD.flexDirectionRow.alignItemsCenter.font-title
        .width2EM.textAlignCenter
          i.fa.fa-arrow-left.cursorPointer(@click="prevPage" v-if="param.index > 0")
        .width2EM.textAlignCenter
          i.fa.fa-close.cursorPointer(@click="param.popup = false")
        .width2EM.textAlignCenter
          i.fa.fa-arrow-right.cursorPointer(@click="nextPage" v-if="param.index < arr.length - 1")
      a.cursorPointer.width10EM.color-white.textDecorationNone(:href="pdf" target="_blank" download)
        i.fa.fa-download.lineHeight2EM(style="font-size: 1.5em")
    .c-popup__content.m-width-90.m-maxWidthNone(@click="stopPropagation($event)")
      .col-24.bgColor-white.textAlignLeft.flexD.flexDirectionRow.justifySpaceBetween
        .col-24(v-if="param.index == 0")
          .font-title-normal.color-title-blue.l-margin-bottom-1em {{ arr[0].title }}
          .col-24(v-for="(item, index) in arr[0].content" :key="index")
            .font-section(v-if="item.type == 'text'") {{ item.content }}
            .font-title-small.l-margin-top-1em.l-margin-bottom-1em(v-if="item.type == 'title'") {{ item.content }}
            .l-margin-top-1em.msFlexNegative(v-if="item.type == 'video'")
              video.block.col-24(:src="item.url" controls="controls" :poster="item.poster")
        .col-24(v-else-if="param.index == 1")
          .col-24.flexD.flexWrap.alignItemsCenter.justifySpaceBetween.l-margin-bottom-1em(v-for="(item, index) in arr[1].content" :key="index" :class="item.className")
            .col-24
              .font-title-normal.color-title-blue.l-margin-bottom-1em.m-textAlignCenter(:class="item.titleClassName") {{ item.title }}
            .col-11.relative.m-width-100
              img.block.col-24(:src="item.image")
              .absolute.font-small-tip(v-if="item.imageCoord" v-for="(t, r) in item.imageCoord" :style="{bottom: t.y, left: t.x}") {{ t.content }}
            .col-12.m-width-100
              .col-24(v-for="(p, q) in item.content" :key="q")
                .font-title-middle.color-title-blue(v-if="p.type == 'title'") {{ p.content }}
                .font-section(v-else-if="p.type == 'text'") {{ p.content }}
                ul.font-ul-circle.l-margin-top-1em.l-margin-bottom-1em(v-else-if="p.type=='list'")
                  li(v-for='(x, y) in p.content' :key='y') {{ x }}
                span.font-gary-tip(v-else-if="p.type=='smallText'") {{ p.content }}

        .col-24(v-else-if="param.index == 2")
          .col-24.flexD.flexWrap.alignItemsCenter.justifySpaceBetween.l-margin-bottom-1em(v-for="(item, index) in arr[2].content" :key="index" :class="item.className")
            .col-24
              .font-title-normal.color-title-blue.l-margin-bottom-1em.m-textAlignCenter(:class="item.titleClassName") {{ item.title }}
            .col-11.relative.m-width-100
              img.block.col-24(:src="item.image")
              .absolute.font-small-tip(v-if="item.imageCoord" v-for="(t, r) in item.imageCoord" :style="{bottom: t.y, left: t.x}") {{ t.content }}
            .col-12.m-width-100
              .col-24(v-for="(p, q) in item.content" :key="q")
                .font-title-middle.color-title-blue(v-if="p.type == 'title'") {{ p.content }}
                .font-section(v-else-if="p.type == 'text'") {{ p.content }}
                ul.font-ul-circle.l-margin-top-1em.l-margin-bottom-1em(v-else-if="p.type=='list'")
                  li(v-for='(x, y) in p.content' :key='y') {{ x }}
                span.font-gary-tip(v-else-if="p.type=='smallText'") {{ p.content }}

</template>

<script>
  export default {
    name: 'popupDietz',
    props: ['content'],
    data(){
      return{
        param: {
          popup: false,
          index: 0
        },
        pdf: "./doc/Rollators彩页.pdf",
        arr: [
          {
            title: this.$t('dietz_popup.item_1.title'),
            content: [
              {type: 'text', content: this.$t('dietz_popup.item_1.content_1')},
              {type: 'text', content: this.$t('dietz_popup.item_1.content_2')},
              {type: 'title', content: this.$t('dietz_popup.item_1.title_1')},
              {type: 'text', content: this.$t('dietz_popup.item_1.content_3')},
              {type: 'text', content: this.$t('dietz_popup.item_1.content_4')},
              {type: 'text', content: this.$t('dietz_popup.item_1.content_5')},
              {type: 'video', url: require('@/assets/media/dietz.mp4'), poster: require('@/assets/img/cover_dietz.jpg')},
            ]
          },
          {
            content: [
              {
                className: 'flexDirectionRow',
                titleClassName: "textAlignLeft",
                image: require('@/assets/img/product_dietz_meco.jpg'),
                title: this.$t('dietz_popup.item_2.content_1.title'),
                content: [
                  {type: 'title', content: this.$t('dietz_popup.item_2.content_1.child_title')},
                  {type: 'list', content: [this.$t('dietz_popup.item_2.content_1.list_1'),this.$t('dietz_popup.item_2.content_1.list_2'),this.$t('dietz_popup.item_2.content_1.list_3'),this.$t('dietz_popup.item_2.content_1.list_4'),this.$t('dietz_popup.item_2.content_1.list_5')]},
                ]
              },
              {
                className: 'flexDirectionRowReverse',
                titleClassName: "textAlignRight",
                image: require('@/assets/img/product_dietz_mgt.jpg'),
                imageCoord: [
                  {content: this.$t('dietz_popup.item_2.content_2.coord_1'), x: "45%", y: "4%"},
                ],
                title: this.$t('dietz_popup.item_2.content_2.title'),
                content: [
                  {type: 'title', content: this.$t('dietz_popup.item_2.content_2.child_title')},
                  {type: 'list', content: [this.$t('dietz_popup.item_2.content_2.list_1'),this.$t('dietz_popup.item_2.content_2.list_2'),this.$t('dietz_popup.item_2.content_2.list_3'),this.$t('dietz_popup.item_2.content_2.list_4'),this.$t('dietz_popup.item_2.content_2.list_5'),this.$t('dietz_popup.item_2.content_2.list_6')]},
                  {type: 'title', content: this.$t('dietz_popup.item_2.content_2.title_1')},
                  {type: 'title', content: this.$t('dietz_popup.item_2.content_2.title_2')},
                  {type: 'smallText', content: this.$t('dietz_popup.item_2.content_2.small_text')},
                ]
              },
            ]
          },
          {
            content: [
              {
                className: 'flexDirectionRow',
                titleClassName: "textAlignLeft",
                image: require('@/assets/img/product_dietz_sgt.jpg'),
                imageCoord: [
                  {content: this.$t('dietz_popup.item_3.content_3.coord_1'), x: "45%", y: "4%"},
                ],
                title: this.$t('dietz_popup.item_3.content_3.title'),
                content: [
                  {type: 'title', content: this.$t('dietz_popup.item_3.content_3.child_title')},
                  {type: 'list', content: [this.$t('dietz_popup.item_3.content_3.list_1'),this.$t('dietz_popup.item_3.content_3.list_2'),this.$t('dietz_popup.item_3.content_3.list_3'),this.$t('dietz_popup.item_3.content_3.list_4'),this.$t('dietz_popup.item_3.content_3.list_5'),this.$t('dietz_popup.item_3.content_3.list_6')]},
                  {type: 'title', content: this.$t('dietz_popup.item_3.content_3.title_1')},
                  {type: 'title', content: this.$t('dietz_popup.item_3.content_3.title_2')},
                  {type: 'smallText', content: this.$t('dietz_popup.item_3.content_3.small_text')},
                ]
              },
              {
                className: 'flexDirectionRow',
                titleClassName: "textAlignLeft",
                image: require('@/assets/img/product_dietz_xc.jpg'),
                imageCoord: [
                  {content: this.$t('dietz_popup.item_3.content_4.coord_1'), x: "14%", y: "38%"},
                  {content: this.$t('dietz_popup.item_3.content_4.coord_2'), x: "64%", y: "8%"},
                ],
                title: this.$t('dietz_popup.item_3.content_4.title'),
                content: [
                  {type: 'title', content: this.$t('dietz_popup.item_3.content_4.child_title')},
                  {type: 'list', content: [this.$t('dietz_popup.item_3.content_4.list_1'),this.$t('dietz_popup.item_3.content_4.list_2'),this.$t('dietz_popup.item_3.content_4.list_3'),this.$t('dietz_popup.item_3.content_4.list_4'),this.$t('dietz_popup.item_3.content_4.list_5')]},
                ]
              },
            ]
          },
        ],
      }
    },
    computed: {},
    watch: {
      content(data) {
        this.param = data
      }
    },
    methods:{
      stopPropagation(e){
        if (e.stopPropagation) {
          e.stopPropagation();
        } else {
          e.cancelBubble = true;
        }
      },
      prevPage(){
        this.param.index -= 1
      },
      nextPage(){
        this.param.index += 1
      }
    },
    created(){}
  }
</script>
